import React,{useState,useEffect} from 'react';
import axios from 'axios';
import JobCard from './JobCard';
import useJobsByCompany from '../Hooks/useJobsByCompany';
import Pagination from '../JobPage/Pagination';
import { Stack } from '../Components/ui/layout';


const JobList = ({companyId}) => {
    const jobs = useJobsByCompany(companyId);
    // Debug log removed — was leaking jobs list to console.

    const [currentPage, setCurrentPage] = useState(1);
      const companiesPerPage = 5;
      const indexOfLastJob = currentPage * companiesPerPage;
      const indexOfFirstJob = indexOfLastJob - companiesPerPage;
      const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);
    
    
      const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
      };
  return (
    <Stack spacing="md" className="flex-1 w-full">
      {currentJobs.map((job, index) => (
        <JobCard key={index} job={job} />
      ))}
      <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(jobs.length / companiesPerPage)}
          onPageChange={handlePageChange}
      />
    </Stack>
  );
};

export default JobList;